import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../src/deprecated/FilteredSearch/FilteredSearch.docs.json';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentProps = makeShortcode("ComponentProps");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p><strong parentName="p">{`Note:`}</strong>{` You `}<em parentName="p">{`must`}</em>{` use a `}<inlineCode parentName="p">{`TextInput`}</inlineCode>{` and `}<inlineCode parentName="p">{`ActionMenu`}</inlineCode>{` (or native `}<inlineCode parentName="p">{`<details>`}</inlineCode>{` and `}<inlineCode parentName="p">{`<summary>`}</inlineCode>{`) in order for this component to work properly.`}</p>
    <h2>{`Deprecation`}</h2>
    <p>{`A new filter component is in progress.`}</p>
    <p>{`Until the new filter component is ready, you can use Button + TextInput + ActionList to reproduce this pattern.`}</p>
    <h2>{`Examples`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<FilteredSearch>
  <ActionMenu>
    <ActionMenu.Button>Filter</ActionMenu.Button>
    <ActionMenu.Overlay>
      <ActionList>
        <ActionList.Item>Item 1</ActionList.Item>
        <ActionList.Item>Item 2</ActionList.Item>
        <ActionList.Item>Item 3</ActionList.Item>
      </ActionList>
    </ActionMenu.Overlay>
  </ActionMenu>
  <TextInput leadingVisual={SearchIcon} />
</FilteredSearch>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      